<template>
    <div class="wallet-manager">
        <div class="list-container">
            <div class="tab-menu">
                <div v-for="(item,i) in baseMenu.concat(Wallets)" class="tab-item" :key="i" :class="{ selected: item.selected }">
                    <p class="ellip td-ulb" @click="selectMenu(item)">{{ item.title }}</p>
                </div>
            </div>
            <div class="component-box" v-if="component" style="float:left;width: 100%;min-height: 100px;">
                <keep-alive>
                    <component :is="component" :item="item"></component>
                </keep-alive>
            </div>
        </div>
    </div>
</template>

<script>

import { mapActions, mapMutations } from 'vuex';
import Alert from '../utils/Alert.js'
import WebSoc from '../utils/WebSoc.js';
import WalletList from '../components/WalletList';
import Wallets from '../components/Wallets.vue';

export default {
    name: 'wallet-manager',
    components: { WalletList, Wallets },
    computed: {
        client_id () { return this.$store.state.client_id },
        cards () { return this.$store.getters.cards },
        wallets () { return this.$store.getters.wallets },
        Wallets () { return this.$store.state.DB.wallets }
    },
    data () {
        return {
            baseMenu: [{ _id: 'Cards', title: 'All Cards', selected: false },{ _id: 'Wallets', title: 'All Wallets', selected: false }],
            item: false,
            component: false
        }
    },
    mounted () {
        this.getWalletsAndCards();
    },
    methods: {
        selectMenu ( item ) {
            this.baseMenu.forEach(m => {
                m.selected = m == item
            });
            this.wallets.forEach(wallet => {
                this.setObjValue({ obj: wallet, k: 'selected', v: wallet == item });
            });
            if ( this.wallets.indexOf(item) > -1 ) {
                this.item = item;
                this.component = false;
                this.$nextTick(() => {
                    this.component = 'WalletList';
                }); 
            }
            if ( item._id == 'Cards' ) {
                this.item = { cards: this.cards, title: 'All Cards' }
                this.component = false;
                this.$nextTick(() => {
                    this.component = 'WalletList';
                }); 
            }
            if ( item._id == 'Wallets' ) {
                this.component = false;
                this.$nextTick(() => {
                    this.component = 'Wallets';
                })
            }
        },
        ...mapActions([
            'getWalletsAndCards'
        ]),
        ...mapMutations([
            'setObjValue'
        ])
    }
}

</script>

<style lang="scss">
.wallet-manager {
    .tab-menu {
        display: flex;
        border-bottom: 1px solid #c0c0c0;
        .tab-item {
            position: relative;
            background-color: rgba(200,200,200,0.4);
            opacity: 0.7;
            &.selected {
                background-color: white;
                opacity: 1;
            }
            > p { padding: 5px 40px 5px 10px; border-right: 1px solid #c0c0c0; }
        }
    }
    .list-container {
        min-height: 100px;
    }
}
</style>